import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import MachineAgencyAddress from "./MachineAgencyAddress";
import MachineAgencyChiefs from "./MachineAgencyChiefs";
import { UserTypes } from "../constants";

const MachineAgency = ({ token }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [agences, setAgences] = useState([]);
  const [agenceId, setAgenceId] = useState(null);
  const [agence, setAgence] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [newAgenceName, setNewAgenceName] = useState("");
  const userType = user.type;
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/agences?limit=1000&offset=0`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    })
      .then(response => setAgences(response.data.data))
      .catch(error => console.error("Erreur récupération agences :", error.message));
  }, [token]);

  useEffect(() => {
    const fetchAgenceData = async () => {
      try {
        const response = await axios.get(`${API_URL}/agences/${agenceId}`, {
          headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
        });
        setAgence(response.data);
        setNewAgenceName(response.data.nom);
      } catch (error) {
        console.error("Erreur récupération agence :", error.message);
      }
    };
    if (agenceId) fetchAgenceData();
    else { setAgence(null); setNewAgenceName(""); }
  }, [agenceId, token]);

  const handleSaveClick = async () => {
    try {
      const response = await axios.patch(
        `${API_URL}/agences/${agenceId}`,
        { nom: newAgenceName },
        { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200 && response.data) {
        setEditMode(false);
        setAgence(response.data.data);
        window.location.reload();
      }
    } catch (error) {
      console.error("Erreur mise à jour agence", error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`${API_URL}/agences/${agenceId}`, {
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
      });
      setAgences(agences.filter((a) => a.id !== agenceId));
      setShowDeleteModal(false);
      setAgenceId(null);
      window.location.reload();
    } catch (error) {
      console.error("Erreur suppression agence :", error.message);
    }
  };

  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-3">Agences</p>

      {/* Sélecteur */}
      <select
        value={agenceId || ""}
        onChange={(e) => setAgenceId(e.target.value)}
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
      >
        <option value="">Sélectionner une agence</option>
        {agences.map((a) => (
          <option key={a.id} value={a.id}>{a.nom}</option>
        ))}
      </select>

      {/* Détail agence */}
      {agence && (
        <div className="mt-4 border border-gray-100 rounded-xl p-4 bg-gray-50 flex flex-col gap-3">

          {/* Nom + édition */}
          {editMode ? (
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                value={newAgenceName}
                onChange={(e) => setNewAgenceName(e.target.value)}
                className="flex-1 border border-gray-200 rounded-xl px-4 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
              />
              <button onClick={handleSaveClick} className="px-4 py-2 bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold rounded-xl transition">
                Valider
              </button>
              <button onClick={() => { setEditMode(false); setNewAgenceName(agence.nom); }} className="px-4 py-2 bg-red-500 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition">
                Annuler
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="font-bold text-loginBordure text-base">{newAgenceName}</span>
              {(userType === UserTypes.SUPER || userType === UserTypes.ADMIN) && (
                <FaEdit className="cursor-pointer text-gray-400 hover:text-loginBordure transition" onClick={() => setEditMode(true)} />
              )}
            </div>
          )}

          <MachineAgencyAddress address={agence.adresse} agenceId={agenceId} agence={agence} token={token} />
          <MachineAgencyChiefs agence={agence} token={token} />

          {userType === UserTypes.SUPER && (
            <button
              onClick={() => setShowDeleteModal(true)}
              className="flex items-center gap-1.5 text-sm text-red-400 hover:text-red-600 transition mt-1 w-fit"
            >
              <FaTrash className="text-xs" />
              Supprimer l'agence
            </button>
          )}
        </div>
      )}

      {/* Modal suppression */}
      {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm mx-4">
            <p className="text-sm text-gray-600 text-center mb-1">Supprimer l'agence</p>
            <p className="text-base font-bold text-gray-800 text-center mb-6">{agence.nom}</p>
            <div className="flex gap-3">
              <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2.5 border border-gray-200 text-gray-600 text-sm font-semibold rounded-xl hover:bg-gray-50 transition">
                Annuler
              </button>
              <button onClick={handleConfirmDelete} className="flex-1 px-4 py-2.5 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold rounded-xl transition">
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineAgency;